import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './AddCommentInput.styled';
import { PlaceholderAvatar, Avatar as StyledAvatar } from '../ActivityFeed.styled';
import { AddCommentModal } from './AddCommentModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AddCommentInput = ({
  loggedInMember,
  hideOnMobileBreakpoint = false,
  onLogin
}) => {
  const {
    t
  } = useTranslation('blocks.activityFeed');
  return /*#__PURE__*/_jsxs(Styled.CommentInputContainer, {
    "data-id": "cp-activity-feed-comment",
    hideOnMobileBreakpoint: hideOnMobileBreakpoint,
    children: [/*#__PURE__*/_jsx(Styled.AvatarContainer, {
      children: loggedInMember?.avatar ? /*#__PURE__*/_jsx(StyledAvatar, {
        src: loggedInMember.avatar,
        width: "36",
        height: "36",
        alt: ""
      }) : /*#__PURE__*/_jsx(PlaceholderAvatar, {})
    }), /*#__PURE__*/_jsx(AddCommentModal, {
      renderTrigger: referenceProps => /*#__PURE__*/_jsx(Styled.FauxCommentInput, {
        "data-id": "cp-activity-feed-add-comment",
        type: "button",
        ...referenceProps,
        children: t('AddCommentInput.fauxCommentInput.label', 'Add a comment...')
      }),
      loggedInMember: loggedInMember,
      onLogin: onLogin
    })]
  });
};